// reducer.js
import * as actionTypes from "./actionsTypes";

const initialState = {
  currentPage: 1,
  value: "",
  corrige: false,
  aCorriger: false,
  enCours: false,
  livre: false,
  enAttenteValidation: false,
  valide: false,
  annule: false,
  date: "",
  statutLiv: "",
  statutReq: "",
  type: "",
  criticite: "",
  selectedOptions: [],
  sortField: "created_at",
  order: "desc",
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_VALUE_TICKET:
      return {
        ...state,
        value: action.payload,
      };
    case actionTypes.SET_CURRENT_PAGE_TICKET:
      return {
        ...state,
        currentPage: action.payload,
      };
    case actionTypes.SET_DATE_TICKET:
      return {
        ...state,
        date: action.payload,
      };
    case actionTypes.SET_CORRIGER_TICKET:
      return {
        ...state,
        corrige: action.payload,
      };
    case actionTypes.SET_A_CORRIGER_TICKET:
      return {
        ...state,
        aCorriger: action.payload,
      };
    case actionTypes.SET_STATUT_LIV_TICKET:
      return {
        ...state,
        statutLiv: action.payload,
      };
    case actionTypes.SET_STATUT_REQ_TICKET:
      return {
        ...state,
        statutReq: action.payload,
      };
    case actionTypes.SET_TYPE_TICKET:
      return {
        ...state,
        type: action.payload,
      };
    case actionTypes.SET_CRITICITE_TICKET:
      return {
        ...state,
        criticite: action.payload,
      };

    case actionTypes.SET_SELECTED_OPTIONS_TICKET:
      return {
        ...state,
        selectedOptions: action.payload,
      };
    case actionTypes.SET_SORT_FIELD_TICKET:
      return {
        ...state,
        sortField: action.payload,
      };
    case actionTypes.SET_ORDER_TICKET:
      return {
        ...state,
        order: action.payload,
      };
    case actionTypes.SET_VALIDE_TICKET:
      return {
        ...state,
        valide: action.payload,
      };
    case actionTypes.SET_ANNULER_TICKET:
      return {
        ...state,
        annule: action.payload,
      };
    case actionTypes.SET_EN_COURS_TICKET:
      return {
        ...state,
        enCours: action.payload,
      };
    case actionTypes.SET_LIVRE_TICKET:
      return {
        ...state,
        livre: action.payload,
      };
    case actionTypes.SET_EN_ATTENTE_VALIDATION_TICKET:
      return {
        ...state,
        enAttenteValidation: action.payload,
      };
    case actionTypes.SET_VALIDE_TICKET:
      return {
        ...state,
        valide: action.payload,
      };
    default:
      return state;
  }
};

export default rootReducer;
